<mat-card>
  <mat-card-header>
    <mat-card-title
      i18n="component formulaire link utilisateur société | titre"
    >
      Lié une société à un utilisateur
    </mat-card-title>
    <mat-card-subtitle>
      {{ user.firstName }} {{ user.lastName }} - @if (user.compagnie) {
      <span i18n="component formulaire link utilisateur société | sous-titre">
        {{ user.compagnie.name }}
      </span>
      } @if (!user.compagnie) {
      <span i18n="component formulaire link utilisateur société | sous-titre">
        aucune
      </span>
      }
    </mat-card-subtitle>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content>
    <form [formGroup]="form" (submit)="submit()">
      <p>
        <mat-form-field appearance="outline">
          <mat-label
            i18n="component formulaire link utilisateur société | champ"
          >
            société liée
          </mat-label>
          <mat-select formControlName="compagnie">
            @for (compagnieOpt of (companies | async)?.data; track compagnieOpt)
            {
            <mat-option [value]="compagnieOpt">
              {{ compagnieOpt.name }}
            </mat-option>
            }
          </mat-select>
          <mat-icon matSuffix>store</mat-icon>
        </mat-form-field>
      </p>
      <mat-divider></mat-divider>
      <mat-card-actions>
        <button
          mat-flat-button
          type="button"
          (click)="cancel()"
          i18n="component formulaire link utilisateur société | bouton"
        >
          annuler
        </button>
        <button
          mat-flat-button
          type="submit"
          color="primary"
          [disabled]="form.invalid"
          i18n="component formulaire link utilisateur société | bouton"
        >
          lier
        </button>
      </mat-card-actions>
    </form>
  </mat-card-content>
  <mat-card-footer>
    @if (formInProgress) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </mat-card-footer>
</mat-card>
